import { render, staticRenderFns } from "./DokmanComponentFreigabeSchritte.vue?vue&type=template&id=5004a6b2&scoped=true"
import script from "./DokmanComponentFreigabeSchritte.vue?vue&type=script&lang=js"
export * from "./DokmanComponentFreigabeSchritte.vue?vue&type=script&lang=js"
import style0 from "./DokmanComponentFreigabeSchritte.vue?vue&type=style&index=0&id=5004a6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004a6b2",
  null
  
)

export default component.exports